module.exports = __webpack_public_path__ + "static/media/modelo-bco.8e7e6d4f.svg";